import React, {useEffect } from 'react';
import "./experience.css";
import Aos from "aos";
import "aos/dist/aos.css";



function Experience() {
    
    useEffect(() => {
        Aos.init({duration: 2000});
    }, [])


    return (
        <div id="experience" className="exp">
            <h1 data-aos="flip-left" >EXPERIENCE</h1>
            <div className="expery">
          
          <div className="year une">
              <h2 data-aos="fade-down" >2015-2016</h2>
              <p data-aos="flip-left" >Tulianza kwa kujikita na kutengeneza blogs za watu mbali mbali, watu binafsi na makampuni, blogs za mziki, blogs za habari , mapishi,
               blogs zetu zilikua ni za aina yake ya tofauti, huu mwaka tulijenga websites yingi sana za aina hii 
              </p>
          </div>

          <div className="year dos">
              <h2 data-aos="fade-down" >2016-2017</h2>
              <p data-aos="flip-left" >Huu mwaka tulijikita zaid katika kutengeneza websites za bishara za kununua na kuuza bidhaa, maarufu kama ecommerce websites,
              tuliweza kutengeneza vitu ambavyo viliridhisha sana wateja wetu na kutuletea umaarufu mkubwa sana wa nje mpaka ndani,  
              </p>
          </div>

          <div className="year tri">
              <h2 data-aos="fade-down" >2017-2018</h2>
              <p data-aos="flip-right" >Huu mwaka ulikua ni mwaka wa changamoto zingine kwetu na tulikua tukianzisha huduma ya kutengeneza websites za cryptocurrency kama bitcoin,
                websites za bitcoin tumetengeneza kwa ufanisi mkubwa sana na kwa teknolojia ya hali ya juu mno
              </p>
          </div>

          <div className="year qatro">
              <h2 data-aos="fade-down" >2019-Sasa</h2>
              <p data-aos="flip-rght" >Tumekua tukifanya projects kubwa sana, tumetengeneza websites kubwa kwajili ya wateja mbali mbali
                  tumetengeneza shoppping websites na blogs, wateja watu wameanza kutuamini tokea zamani saana,hauna sababu ya kua na waswas na sisi
                  unataka matokeoo...sisi tunayo matokeo!! 
              </p>
          </div>  
           
          <div className="circle one">
              <div className="orange">
              </div>
          </div>

          <div className="circle two">
              <div className="orange">
              </div>
          </div>

          <div className="circle three">
              <div className="orange">
              </div>
          </div>

          <div className="circle four">
              <div className="orange">
              </div>
          </div>

          <div className="circle five">
              <div className="orange">
              </div>
          </div>

          </div>
        </div>
    )
}

export default Experience
